import React from 'react';

import DiscoverAlbumFolderSuccessContainer from '../../containers/discover/DiscoverAlbumFolderSuccessContainer';

const DiscoverAlbumFolderSuccessView = () => (
  <DiscoverAlbumFolderSuccessContainer />
);

export default DiscoverAlbumFolderSuccessView;
